import { Component, OnInit } from '@angular/core';
import { ColumnMode } from '@swimlane/ngx-datatable';
import { CurrencyPipe } from '@angular/common';
import { Chart } from 'chart.js';
import { ReportsService } from '../../../services/report.service';
import { UserService } from '../../../services/user.service';
import * as moment from 'moment';
import { ToasterService } from '../../../services/toaster.service';

@Component({
  selector: 'establishment-report',
  templateUrl: './establishment-report.component.html',
  styleUrls: ['./establishment-report.component.scss', '../reports.component.scss'],
  providers: [CurrencyPipe]
})
export class EstablishmentReportComponent implements OnInit {

  columnModes = ColumnMode;
  grownMetricsRows: any[] = [];
  topCompaniesRows: any[] = [];
  activeAccount;

  grownMetricsColumns = [
    { prop: 'period', name: '', flexGrow: 2 },
    { prop: 'view_total', name: 'Visualizações', flexGrow: 1 },
    { prop: 'coupons', name: 'Cupons Gerados', flexGrow: 1 },
    { prop: 'launched_coupons', name: 'Cupons Lançados', flexGrow: 1 },
    { prop: 'revenue_released_formated', name: 'Receita Lançada', flexGrow: 1 },
    { prop: 'potential_economy_formated', name: 'Receita Potencial', flexGrow: 1 },
    { prop: 'potential_revenue_formated', name: 'Total em Desconto', flexGrow: 1 },
  ];

  topCompaniesColumns = [
    { prop: 'position', name: '', flexGrow: 0 },
    { prop: 'companyName', name: '', flexGrow: 2 },
    { prop: 'views', name: 'Visualizações', flexGrow: 1 },
    { prop: 'coupons', name: 'Cupons Gerados', flexGrow: 1 },
    { prop: 'coupons_launched', name: 'Cupons Lançados', flexGrow: 1 },
    { prop: 'revenue', name: 'Receita Lançada', flexGrow: 1 }
  ];

  constructor(
    private currencyPipe: CurrencyPipe,
    private reportsService: ReportsService,
    private userService: UserService,
    private toasterService: ToasterService,
  ) {}

  ngOnInit() {
    this.activeAccount = this.userService.getLoggedAccount();
    this.getReports();
    this.getTopCompanies();
  }

  getReports() {
    this.reportsService.getEstablishmentReports(this.activeAccount.id).then(res => {
      this.grownMetricsRows = res.data.map(el => ({
        ...el,
        period: moment.utc({month: el.month, year: el.year}).format('MMM/YY'),
        revenue_released_formated: this.transformCurrency(el.revenue_released),
        potential_economy_formated: this.transformCurrency(el.potential_economy),
        potential_revenue_formated: this.transformCurrency(el.potential_revenue),
      }));

      this.initChart();
    }, () => {
      this.toasterService.info('Ops!', 'Não conseguimos consultar alguns dos dados do relatório. Por favor, tente novamente.', false, 8000);
    });
  }

  getTopCompanies() {
    this.reportsService.getTopCompanies(this.activeAccount.id).then(res => {
      this.topCompaniesRows = res.map((el, index) => ({...el, position: index + 1, revenue: this.transformCurrency(el.revenue_released)}));
    }, () => {
      this.toasterService.info('Ops!', 'Não conseguimos consultar alguns dos dados do relatório. Por favor, tente novamente.', false, 8000);
    });
  }

  transformCurrency(value) {
    return this.currencyPipe.transform(value, 'BRL', 'symbol', '1.0-0');
  }

  initChart() {
    setTimeout(() => {
      const chart = new Chart('canvas', {
        type: 'line',
        data: {
          labels: this.grownMetricsRows.map(el => el.period).reverse(),
          datasets: [
            {
              backgroundColor: ['rgba(208, 0, 111, 0)'],
              borderColor: ['rgba(208, 0, 111, 1)'],
              borderWidth: 3,
              label: 'Visualizações',
              data: this.grownMetricsRows.map(el => el.view_total).reverse(),
            },
            {
              backgroundColor: ['rgba(0, 155, 164, 0)'],
              borderColor: ['rgba(0, 155, 164, 1)'],
              borderWidth: 3,
              label: 'Cupons gerados',
              data: this.grownMetricsRows.map(el => el.coupons).reverse(),
            },
            {
              backgroundColor: ['rgba(0, 155, 164, 0)'],
              borderColor: ['rgba(255, 103, 76, 1)'],
              borderWidth: 3,
              label: 'Cupons Lançados',
              data: this.grownMetricsRows.map(el => el.coupons_launched).reverse(),
            },
          ],
        },
        options: {
          responsive: true,
          scales: {
            xAxes: [{ gridLines: { color: '#F0F0F0' } }],
            yAxes: [{
              gridLines: { color: '#F0F0F0' },
              ticks: { fontFamily: 'Roboto' },
            }],
          }
        },
      });
    }, 200);
  }

}
